import { render, staticRenderFns } from "./datasubject-boxes-for-datasource.vue?vue&type=template&id=2e538127&scoped=true"
import script from "./datasubject-boxes-for-datasource.vue?vue&type=script&lang=js"
export * from "./datasubject-boxes-for-datasource.vue?vue&type=script&lang=js"
import style0 from "./datasubject-boxes-for-datasource.vue?vue&type=style&index=0&id=2e538127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e538127",
  null
  
)

export default component.exports